import strategyPaperInitState from "../InitStates/strategy-papyer-init-state";
import decisionSheetInitState from "../InitStates/decision-sheet-init-state";
import AnnualReportInitStatement from "../InitStates/annual-report-init-state";

const initState = {
	StrategyPaper: { ...strategyPaperInitState },
	DecisionSheet: { ...decisionSheetInitState },
	AnnualReport: { ...AnnualReportInitStatement }
}

// Deep-merge the incoming form data over the default init state.
// Saved forms from older sessions may miss whole sections or periods
// (e.g. cashFlow added later) - merging keeps those fields at their
// defaults instead of leaving them undefined and crashing the views.
const mergeForm = (defaults, value) => {
	if (Array.isArray(defaults) || typeof defaults !== "object" || defaults === null) {
		return (value !== undefined) ? value : defaults;
	}

	const merged = { ...defaults };
	if (typeof value === "object" && value !== null) {
		Object.keys(value).forEach((key) => {
			merged[key] = mergeForm(defaults[key], value[key]);
		});
	}

	return merged;
}

const formInitStates = {
	StrategyPaper: strategyPaperInitState,
	DecisionSheet: decisionSheetInitState,
	AnnualReport: AnnualReportInitStatement
}

const reducer = (state = initState, action) => {
	if (action.type === "UPDATE_FORM") {
		return {
			...state,
			[action.form]: mergeForm(formInitStates[action.form] || {}, action.value)
		}
  } else if (Object.prototype.hasOwnProperty.call(formInitStates, action.type)) {
    const form = state[action.type];
    const section = form[action.section] || {};
    // Annual report option is the parent of field; the other forms use
    // section.field.option. Match the persistence paths exactly.
    const parent = action.type === "AnnualReport" ? action.option : action.field;
    const child = action.type === "AnnualReport" ? action.field : action.option;
    const nextSection = action.option === undefined
      ? { ...section, [action.field]: action.value }
      : { ...section, [parent]: { ...section[parent], [child]: action.value } };
    return { ...state, [action.type]: { ...form, [action.section]: nextSection } };
  }

	return state;
}

export default reducer;
